<template>
  <div class="overflow-x-auto border border-slate-200 bg-white">
    <table class="min-w-full divide-y divide-slate-200 text-sm">
      <thead class="bg-slate-50">
        <tr>
          <th scope="col" class="px-4 py-3 text-left font-semibold text-slate-700">
            {{ t('sensor.door_open_chart.start') }}
          </th>
          <th scope="col" class="px-4 py-3 text-left font-semibold text-slate-700">
            {{ t('sensor.door_open_chart.end') }}
          </th>
          <th scope="col" class="px-4 py-3 text-left font-semibold text-slate-700">
            {{ t('sensor.door_open_chart.duration') }}
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-slate-200">
        <tr v-for="(period, idx) in periods" :key="idx" class="hover:bg-slate-50">
          <td class="px-4 py-3 tabular-nums text-slate-600">{{ formatCellDateTime(period.start_date) }}</td>
          <td class="px-4 py-3 tabular-nums text-slate-600">{{ formatCellDateTime(period.end_date) }}</td>
          <td class="px-4 py-3 font-medium text-slate-800">{{ formatPeriodDuration(period) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '@/composable/useI18n'
import type { IDoorOpenPeriod } from '@/utils/door-open-periods'

const props = defineProps<{
  periods: IDoorOpenPeriod[]
  showSeconds?: boolean
  formatDateTime: (dateStr: string | null) => string
  formatPeriodDuration: (period: IDoorOpenPeriod) => string
}>()

const { t } = useI18n()

const dateTimeFormatOptions = computed<Intl.DateTimeFormatOptions>(() => ({
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  ...(props.showSeconds ? { second: '2-digit' as const } : {}),
}))

function formatCellDateTime(dateStr: string | null): string {
  if (!dateStr) return t('sensor.door_open_chart.open_ended')
  if (!props.showSeconds) return props.formatDateTime(dateStr)
  return new Date(dateStr).toLocaleString('pt-BR', dateTimeFormatOptions.value)
}
</script>
